<template>
  <div>
    <el-form inline label-width="120px" label-position="right" size="mini">
      <el-form-item :label="$ct('unitName')">
        <el-input v-model="name" style="width:120px" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$ct('proposer')">
        <el-input v-model="applicant_name" style="width:130px" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$ct('applicationTime')">
        <el-date-picker
          v-model="created_at_from"
          class="m-r-5"
          type="datetime"
          :placeholder="$ct('startTime')"
        ></el-date-picker>
        <el-date-picker v-model="created_at_to" type="datetime" :placeholder="$ct('endTime')"></el-date-picker>
      </el-form-item>
      <div class="button-div">
        <el-button round size="mini" type="primary" @click="getData">{{$ct('search')}}</el-button>
        <el-button round size="mini" @click="reset">{{$ct('reset')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
.button-div {
  text-align: center;
  width: 100%;
  margin-bottom: 30px;
}
</style>

<script>
export default {
  data() {
    return {
      something: ''
    }
  },
  computed: {
    applicant_name: {
      get() {
        return this.$store.state.unitManage.applicant_name
      },
      set(applicant_name) {
        this.$store.commit('setState', {
          module: 'unitManage',
          key: 'applicant_name',
          value: applicant_name
        })
      }
    },
    created_at_from: {
      get() {
        return this.$store.state.unitManage.created_at_from
      },
      set(created_at_from) {
        this.$store.commit('setState', {
          module: 'unitManage',
          key: 'created_at_from',
          value: created_at_from
        })
      }
    },
    created_at_to: {
      get() {
        return this.$store.state.unitManage.created_at_to
      },
      set(created_at_to) {
        this.$store.commit('setState', {
          module: 'unitManage',
          key: 'created_at_to',
          value: created_at_to
        })
      }
    },
    name: {
      get() {
        return this.$store.state.unitManage.name
      },
      set(name) {
        this.$store.commit('setState', {
          module: 'unitManage',
          key: 'name',
          value: name
        })
      }
    },
    role_id() {
      return this.$store.state.user.role_id
    }
  },
  methods: {
    getData() {
      this.$emit('getData')
    },
    reset() {
      this.$store.commit('unitManageInit')
      this.$emit('getData')
    }
  }
}
</script>
